export default import.meta.ROLLDOWN_FILE_URL_m8GAGfa9cuJ5yLVKM$V41w